<template>
  <div>
    <div style="padding: 20px;">
      <quote-notes-form :quote-id="quoteId" @note-added="onNoteAdded"></quote-notes-form>
    </div>

    <ul v-if="notes && notes.length > 0" class="notes-index list-unstyled">
      <li v-for="note in notes" :key="note.id" class="note p-3">
        <div class="d-flex justify-content-between align-items-start mb-0">
            <h6 class="d-block font-weight-bold text-dark mx-0 mt-0 mb-1">{{ note.user.name }}</h6>

            <span class="text-nowrap text-muted">{{formatDateTime(new Date(note.created_at))}}</span>
        </div>

        <p class="whitespace-pre-line">{{ note.note }}</p>
      </li>
    </ul>

    <div class="text-center my-3">
      <SbSpinner v-if="isLoading">
      </SbSpinner>

      <button v-else-if="nextUrl" role="button" class="btn btn-primary" @click.prevent="loadMore">
        Ladda fler
      </button>
    </div>
  </div>
</template>

<style scoped>
.whitespace-pre-line {
  white-space: pre-line;
}
</style>

<script setup lang="ts">
import { onMounted, ref, toRefs } from "vue";
import axios from 'axios';
const DATETIME_FORMATTER = new Intl.DateTimeFormat('default', {
  dateStyle: 'short',
  timeStyle: 'short'
});
const props = defineProps({
  quoteId: {
    type: Number,
    required: true
  }
});
const {
  quoteId
} = toRefs(props);
const notes = ref([]);
const nextUrl = ref(null);
const isLoading = ref(false);
const users = ref([]);
async function loadMore() {
  try {
    isLoading.value = true;
    const response = await axios.get(nextUrl.value);
    nextUrl.value = response.data.links.next;
    notes.value = [...notes.value, ...response.data.data];
  } finally {
    isLoading.value = false;
  }
}
function onNoteAdded(note) {
  notes.value.unshift(note);
}
function formatDateTime(date) {
  return DATETIME_FORMATTER.format(date);
}
onMounted(async () => {
  notes.value = [];
  nextUrl.value = route('quote.notes.index', quoteId.value);
  await loadMore();
});
</script>
